import React from 'react'
import {Link} from 'react-router'

export default {
  login: 'Entrar',
  email: 'Email',
  twoFactor: 'Two factor code',
  password: 'Contraseña',
  confirmPassword: 'Confirmar contraseña',
  register: 'Registrarme',
  passwordDoesntMatch: 'La contraseña es incorrecta',
  otherLinksInRegister: () => (
    <div>
      Si tienes una cuenta <Link to="/login">inicia sesión</Link>
    </div>
  ),
  otherLinksInLogin: () => (
    <div>
      <div>
        Si no tienes una cuenta, <Link to="/register">registrate</Link>
      </div>
    </div>
  )
}
// If you do not have an account you can <Link to="/register">register</Link>
// . If you forgot your password <Link to="/forgot">click here</Link>



// WEBPACK FOOTER //
// ./src/App/i18n/strings/auth/pages/en.js